// Mock seed data for BizDocs Manager
// NOTE: This is MOCKED data persisted to localStorage on first load.

export const COMPANY = {
  name: 'ACME Sdn Bhd',
  regNo: '202301012345 (1501234-A)',
  address: 'No. 12, Jalan Teknologi 3/5, Kota Damansara, 47810 Petaling Jaya, Selangor',
  phone: '+60 3-6142 8899',
  email: 'hello@acme.com.my',
  website: 'www.acme.com.my',
  sstNo: 'W10-1808-32000123',
  sstRate: 6,
  logoText: 'ACME',
  logoUrl: '',
  chopUrl: '',
  signatureUrl: '',
  signedBy: 'Farah Aziz',
  signedByTitle: 'Managing Director',
  primaryColor: '#2563eb',
  quotationPrefix: 'QT',
  invoicePrefix: 'INV',
  receiptPrefix: 'RCP',
  voucherPrefix: 'PV',
  proposalPrefix: 'PRP',
  includeYear: true,
  numberPadding: 4,
  nextNumbers: {},
  terms: 'Payment due within 30 days. Goods sold are not returnable. All prices are inclusive of SST where applicable.',
  bank: 'Maybank Berhad',
  bankAccount: '5124 1234 5678',
};

export const CUSTOMERS = [
  { id: 'c1', name: 'ABC Sdn Bhd', contact: 'Ahmad Faisal', email: 'ahmad@abc.com.my', phone: '+60 12-345 6789', address: '88 Jalan Ampang, 50450 Kuala Lumpur', outstanding: 4500 },
  { id: 'c2', name: 'XYZ Trading', contact: 'Lim Wei Sheng', email: 'weisheng@xyz.com.my', phone: '+60 16-222 8888', address: '21 Lorong Maarof, 59000 Kuala Lumpur', outstanding: 0 },
  { id: 'c3', name: 'Maju Enterprise', contact: 'Siti Nurhaliza', email: 'siti@maju.com.my', phone: '+60 19-876 5432', address: '5 Jalan SS15/4, 47500 Subang Jaya, Selangor', outstanding: 7500 },
  { id: 'c4', name: 'Sinar Jaya Sdn Bhd', contact: 'Rajesh Kumar', email: 'rajesh@sinarjaya.my', phone: '+60 13-444 2211', address: '9 Jalan Gasing, 46000 Petaling Jaya, Selangor', outstanding: 3200 },
  { id: 'c5', name: 'Tech Nova Solutions', contact: 'Chong Mei Ling', email: 'meiling@technova.my', phone: '+60 17-999 1122', address: '3 Jalan Kia Peng, 50450 Kuala Lumpur', outstanding: 0 },
  { id: 'c6', name: 'Bumi Hijau Resources', contact: 'Zulkifli Hassan', email: 'zul@bumihijau.my', phone: '+60 11-2345 6677', address: '14 Jalan Bukit Bintang, 55100 Kuala Lumpur', outstanding: 5500 },
];

export const PRODUCTS = [
  { id: 'p1', name: 'Website Design Package', description: 'Responsive corporate website (up to 8 pages)', unit: 'project', price: 8500, taxable: true },
  { id: 'p2', name: 'Monthly SEO Retainer', description: 'Search engine optimisation services', unit: 'month', price: 1800, taxable: true },
  { id: 'p3', name: 'Cloud Hosting (Business)', description: 'Managed cloud hosting, 99.9% uptime', unit: 'year', price: 1200, taxable: true },
  { id: 'p4', name: 'Logo & Branding Kit', description: 'Logo, brand guide, stationery design', unit: 'project', price: 3500, taxable: true },
  { id: 'p5', name: 'Consultation (Hourly)', description: 'Business & IT consultation', unit: 'hour', price: 250, taxable: false },
  { id: 'p6', name: 'Mobile App Development', description: 'Cross-platform mobile application', unit: 'project', price: 25000, taxable: true },
];

const d = (offset) => {
  const dt = new Date('2025-04-24');
  dt.setDate(dt.getDate() + offset);
  return dt.toISOString().slice(0, 10);
};

export const QUOTATIONS = [
  { id: 'q1', number: 'QT-2025-0018', customerId: 'c3', date: d(-6), validUntil: d(24), status: 'pending', items: [{ productId: 'p1', name: 'Website Design Package', qty: 1, price: 8500, taxable: true }], notes: 'Awaiting client approval.' },
  { id: 'q2', number: 'QT-2025-0017', customerId: 'c1', date: d(-12), validUntil: d(18), status: 'accepted', items: [{ productId: 'p4', name: 'Logo & Branding Kit', qty: 1, price: 3500, taxable: true }, { productId: 'p2', name: 'Monthly SEO Retainer', qty: 3, price: 1800, taxable: true }], notes: '' },
  { id: 'q3', number: 'QT-2025-0016', customerId: 'c5', date: d(-20), validUntil: d(10), status: 'draft', items: [{ productId: 'p6', name: 'Mobile App Development', qty: 1, price: 25000, taxable: true }], notes: 'Draft, pending scope confirmation.' },
  { id: 'q4', number: 'QT-2025-0015', customerId: 'c2', date: d(-25), validUntil: d(5), status: 'rejected', items: [{ productId: 'p3', name: 'Cloud Hosting (Business)', qty: 2, price: 1200, taxable: true }], notes: 'Client chose another vendor.' },
];

export const INVOICES = [
  { id: 'i1', number: 'INV-2025-0025', customerId: 'c1', date: d(-2), dueDate: d(28), status: 'unpaid', items: [{ productId: 'p4', name: 'Logo & Branding Kit', qty: 1, price: 3500, taxable: true }, { productId: 'p5', name: 'Consultation (Hourly)', qty: 4, price: 250, taxable: false }], amountPaid: 0 },
  { id: 'i2', number: 'INV-2025-0024', customerId: 'c2', date: d(-4), dueDate: d(26), status: 'paid', items: [{ productId: 'p2', name: 'Monthly SEO Retainer', qty: 1, price: 1800, taxable: true }, { productId: 'p3', name: 'Cloud Hosting (Business)', qty: 1, price: 1200, taxable: true }], amountPaid: 3180 },
  { id: 'i3', number: 'INV-2025-0023', customerId: 'c3', date: d(-10), dueDate: d(-2), status: 'overdue', items: [{ productId: 'p1', name: 'Website Design Package', qty: 1, price: 8500, taxable: true }], amountPaid: 4000 },
  { id: 'i4', number: 'INV-2025-0022', customerId: 'c4', date: d(-15), dueDate: d(15), status: 'partial', items: [{ productId: 'p2', name: 'Monthly SEO Retainer', qty: 2, price: 1800, taxable: true }], amountPaid: 2000 },
  { id: 'i5', number: 'INV-2025-0021', customerId: 'c6', date: d(-18), dueDate: d(12), status: 'paid', items: [{ productId: 'p5', name: 'Consultation (Hourly)', qty: 10, price: 250, taxable: false }], amountPaid: 2500 },
];

export const RECEIPTS = [
  { id: 'r1', number: 'RCP-2025-0008', customerId: 'c2', invoiceNumber: 'INV-2025-0024', date: d(-3), amount: 3180, method: 'Bank Transfer' },
  { id: 'r2', number: 'RCP-2025-0007', customerId: 'c6', invoiceNumber: 'INV-2025-0021', date: d(-16), amount: 2500, method: 'Cheque' },
  { id: 'r3', number: 'RCP-2025-0006', customerId: 'c3', invoiceNumber: 'INV-2025-0023', date: d(-8), amount: 4000, method: 'Cash' },
  { id: 'r4', number: 'RCP-2025-0005', customerId: 'c4', invoiceNumber: 'INV-2025-0022', date: d(-12), amount: 2000, method: 'Online Banking' },
];

export const VOUCHERS = [
  { id: 'v1', number: 'PV-2025-0012', payee: 'Trainer Payment - En. Kamal', date: d(-1), amount: 1500, method: 'Bank Transfer', category: 'Training', status: 'paid', notes: 'Corporate training session.' },
  { id: 'v2', number: 'PV-2025-0011', payee: 'Office Supplies Sdn Bhd', date: d(-5), amount: 780, method: 'Cheque', category: 'Supplies', status: 'paid', notes: '' },
  { id: 'v3', number: 'PV-2025-0010', payee: 'CloudHost Malaysia', date: d(-9), amount: 1200, method: 'Online Banking', category: 'Software', status: 'draft', notes: 'Annual server renewal.' },
  { id: 'v4', number: 'PV-2025-0009', payee: 'Freelance Designer', date: d(-14), amount: 2200, method: 'Bank Transfer', category: 'Contractor', status: 'draft', notes: '' },
];

export const PROPOSALS = [
  { id: 'pr1', number: 'PRP-2025-0007', customerId: 'c5', title: 'Digital Transformation Roadmap', date: d(-2), status: 'sent', value: 45000, summary: 'End-to-end digital transformation covering web, mobile and cloud migration.' },
  { id: 'pr2', number: 'PRP-2025-0006', customerId: 'c3', title: 'E-Commerce Platform Build', date: d(-7), status: 'draft', value: 32000, summary: 'Custom e-commerce platform with payment gateway integration.' },
  { id: 'pr3', number: 'PRP-2025-0005', customerId: 'c1', title: 'Annual Marketing Retainer', date: d(-13), status: 'accepted', value: 21600, summary: '12-month digital marketing and SEO retainer.' },
];

export const CASHFLOW = [
  { month: 'Jan', sales: 28000, payments: 22000, outstanding: 9000 },
  { month: 'Feb', sales: 32000, payments: 26000, outstanding: 11000 },
  { month: 'Mar', sales: 30000, payments: 28000, outstanding: 8000 },
  { month: 'Apr', sales: 38000, payments: 30000, outstanding: 12000 },
  { month: 'May', sales: 42000, payments: 35000, outstanding: 13000 },
  { month: 'Jun', sales: 45800, payments: 38000, outstanding: 12500 },
];

export const USERS = [
  { id: 'u1', name: 'Farah Aziz', email: 'farah@acme.com.my', role: 'Administrator', status: 'active' },
  { id: 'u2', name: 'David Tan', email: 'david@acme.com.my', role: 'Finance / Accounts', status: 'active' },
  { id: 'u3', name: 'Nisha Devi', email: 'nisha@acme.com.my', role: 'Sales / Admin', status: 'active' },
  { id: 'u4', name: 'Wong Ka Fai', email: 'kafai@acme.com.my', role: 'Sales / Admin', status: 'invited' },
];
